import { render } from "./TableJobs.vue?vue&type=template&id=21d0d8c9"
import script from "./TableJobs.vue?vue&type=script&lang=js"
export * from "./TableJobs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__